import React from 'react';
import { LibraryItem } from './types';

type Character = NonNullable<LibraryItem['character']>;
export function CharacterFields({ character, onChange }: { character: Character; onChange: (value: Character) => void }) {
  const textField = (key: 'wears' | 'carries' | 'detail' | 'abilityDescription', label: string) => <label key={key}>{label}<textarea rows={2} value={character[key] || ''} onChange={event => onChange({ ...character, [key]: event.target.value })} /></label>;
  return <>
    <fieldset className="library-card-side"><legend>Front of card · Character</legend>
      <p>The quick introduction beside the artwork.</p>
      <label>Traits <small>Separated by commas</small><input value={(character.traits || []).join(', ')} onChange={event => onChange({ ...character, traits: event.target.value.split(',').map(value => value.trim()) })} /></label>
      <label>Colors <small>Separated by commas; the first two appear on the front.</small><input value={(character.colors || []).join(', ')} onChange={event => onChange({ ...character, colors: event.target.value.split(',').map(value => value.trim()) })} /></label>
      <label>Special ability<input value={character.ability || character.move || ''} onChange={event => onChange({ ...character, ability: event.target.value, move: '' })} /></label>
      {textField('abilityDescription', 'Ability effect')}
    </fieldset>
    <fieldset className="library-card-side"><legend>Back of card · Character details</legend>
      <p>Extra details revealed when the card is flipped.</p>
      {textField('wears', 'Wears')}{textField('carries', 'Carries or uses')}{textField('detail', 'Special detail')}
    </fieldset>
  </>;
}
